import { SquareDownArrow, SquareUpArrow, UnionIcon } from 'assests/GmsIcons';
import React, { useState } from 'react';

type TSelectTarget = {
    options: { sourceName: string, targetName: string }[],
    header: string;
}

const ChipsDropDownWithComparison = ({ options, header }: TSelectTarget) => {
    const [expand, setExpand] = useState<boolean>(false)
    return (
        <div className={`tw-w-full tw-h-auto tw-px-2.5 tw-bg-surface tw-rounded tw-border tw-border-edge tw-justify-center tw-items-center tw-gap-2.5 `}>
            <div className="tw-border-edge tw-h-9 tw-justify-center tw-items-center tw-gap-2.5 tw-flex"  >
                <div className="tw-grow tw-shrink tw-basis-0 tw-text-ink">{header}</div>
                <div className="tw-text-ink">{options.length}</div>
                <div role="button" data-testid="components-chipsdropdownwithcomparison-div-1" onClick={() => setExpand(prev => !prev)}>
                    {
                        expand ?
                            <SquareUpArrow /> :
                            <SquareDownArrow />
                    }
                </div>
            </div >
            {
                expand ?
                    <>
                        {<div className="tw-w-full tw-h-[0px] tw-mb-2 tw-border tw-border-edge"></div>}
                        <div className='tw-h-auto  tw-w-auto tw-overflow-y-auto tw-mb-2'>
                            {options?.length === 0 ? <p className='tw-text-ink-tertiary'>No Data </p> : null}
                            {options?.map((option, index) =>
                                <div key={index} className="tw-px-[8px] tw-bg-surface-sunken tw-m-1 tw-rounded-sm tw-justify-center tw-items-center tw-gap-2.5 tw-inline-flex">
                                    <div className="tw-text-ink  tw-text-sm tw-w-auto tw-flex">
                                        {option?.sourceName}
                                        <div className='tw-m-2'>
                                            <UnionIcon />
                                        </div>
                                        {option?.targetName}
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                    : null
            }
        </div >
    )
}

export default ChipsDropDownWithComparison;